import { Component, EventEmitter, OnInit, Input, Output, ViewChild } from '@angular/core';
import { Router }            from '@angular/router';
import {Message, OverlayPanel, SelectItem, ConfirmDialog, ConfirmationService, SplitButton, MenuItem} from 'primeng/primeng';

//constants

import * as ent from '../../entities/index'
import * as filters from '../../filters/index'
import * as serv from '../../services/index'

//constants
import { Constants }         from '../../constants/Constants';

//components
import {LogMessageDetailComponent} from '../../components/Admin/LogMessageDetail.component';

@Component({
  selector: 'my-logmessages-grid',
  templateUrl: './LogMessagesGrid.component.html'
})
export class LogMessagesGridComponent implements OnInit {

    logMessages: ent.LogMessage[];
    logMessage: ent.LogMessage;
    startDate: Date;
    endDate: Date;
    requestID?: number;
    userInfo: ent.UserInfo;

    @ViewChild(LogMessageDetailComponent) logMessageDetailComponent: LogMessageDetailComponent;

    constructor(private authenticationService: serv.AuthenticationService, private adminService: serv.AdminService, private router: Router) {
        this.startDate = new Date();
        this.endDate = new Date();
        this.logMessage = new ent.LogMessage();

    }

    ngOnInit(): void {
        this.userInfo = this.authenticationService.getUserInfo();
    }

    onSearchClick(event: any){
        var filter: filters.LogMessageFilter = 
        {
            RequestID: this.requestID,
            StartDate: this.startDate,
            EndDate: this.endDate,
            GetDataRequest: {Employee: this.userInfo.Employee}
        };
        
        this.adminService.getLogMessages(filter).subscribe(x=>
            {
                this.logMessages = x;
            }
        );
    }

    onViewDetailsClick(event: any, logMessage: ent.LogMessage){
        this.logMessage = logMessage;
        this.logMessageDetailComponent.displayDialog = true;
    }

    
}